// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function memoize<T extends (...args: any[]) => any>(
  // export function memoize<T extends (...args: Parameters<T>[]) => ReturnType<T>>(
  func: T,
): (...args: Parameters<T>) => ReturnType<T> {
  const cache: { [key: string]: ReturnType<T> } = {}

  return (...args: Parameters<T>): ReturnType<T> => {
    const strKey = args.join(',')
    if (!(strKey in cache)) {
      // eslint-disable-next-line prefer-spread
      cache[strKey] = func.apply(null, args)
    }
    return cache[strKey]
  }
}
